var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPmPaypal = function SvgPmPaypal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.889 6.25H32.11c.912 0 1.639.716 1.639 1.583v18.334c0 .867-.727 1.583-1.639 1.583H1.89c-.912 0-1.639-.716-1.639-1.583V7.833c0-.867.727-1.583 1.639-1.583Z",
    fill: "#F5F5F5",
    stroke: "#1D3586",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.034 17.676c2.205 0 3.992-1.718 3.992-3.838a3.7 3.7 0 0 0-.168-1.103 3.685 3.685 0 0 1 2.604 1.654c.341.536.538 1.167.538 1.841 0 1.95-1.644 3.532-3.673 3.532h-1.445a.886.886 0 0 0-.883.72l-.485 2.799a.885.885 0 0 1-.883.719h-2.033c-.55 0-.97-.471-.884-.994l.127-.724.674-3.887a.886.886 0 0 1 .883-.719h1.636Z",
    fill: "#009DDC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.034 17.676c2.205 0 3.992-1.718 3.992-3.838a3.702 3.702 0 0 0-.585-2C19.74 10.736 18.476 10 17.034 10h-4.423a.885.885 0 0 0-.884.728l-1.716 10.56c-.085.522.335.994.884.994h2.946l.674-3.887a.885.885 0 0 1 .883-.719h1.636Z",
    fill: "#1D3586"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.034 17.676c2.205 0 3.992-1.718 3.992-3.838a3.7 3.7 0 0 0-.168-1.103h-4.517a1 1 0 0 0-.985.829l-.841 4.83a.886.886 0 0 1 .883-.718h1.636Z",
    fill: "#211D70"
  })));
};
export default SvgPmPaypal;